export default __webpack_public_path__ + "c96a8a1b372829ba2d5396ee09b170c4.png";